import { useEffect } from 'react'
import { getListMessageTopics } from '../../../services/sBook/messageTopic.service'


const useGetMessageTopicsMaintainer = (mantainerList, setMantainer) => {
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getListMessageTopics();
                const response = serviceResponse.data;
                const aux_array = [];

                response.data.forEach(element => {
                    aux_array.push({ id: element.id, name: element.name, messageTopicCode: element.messageTopicCode, messageTopicNemo: element.messageTopicNemo, hidden: element.hidden ?? false })
                });

                setMantainer(aux_array);
            }
            catch (error) {
                setMantainer([])
            }
        }

        if (mantainerList === null) {
            getData()
        }
    }, [mantainerList, setMantainer]);
}

export {
    useGetMessageTopicsMaintainer
}
